import { Create as RaCreate, CreateProps as RaCreateProps } from 'react-admin';

export const Create = RaCreate;

export type CreateProps = RaCreateProps;
